import { ComponentType as n } from "../../registries/types/propTypes.js";
const r = (e) => {
  const o = Array.isArray(e.hero_component) ? e.hero_component[0] : e.hero_component;
  return {
    componentType: n.hero_component,
    heroDescription: o.sub_title,
    heroTitle: o.display_title,
    images: o.image.images,
    tagline: o.tagline,
    ctaButton: o.link
  };
};
export {
  r as default
};
//# sourceMappingURL=hero-component-transformer.js.map
